import {Color} from "exceljs";
import {mutateColorToExcelJsFormat} from "./color";
import {IExportExcelStylesFont} from "@containers/export/containers/excel/types";

interface IFontExcelJs {
    name?: string;
    size?: number;
    family?: number;
    scheme?: 'minor' | 'major' | 'none';
    charset?: number;
    color?: Partial<Color>;
    bold?: boolean;
    italic?: boolean;
    underline?: boolean | 'none' | 'single' | 'double' | 'singleAccounting' | 'doubleAccounting';
    vertAlign?: 'superscript' | 'subscript';
    strike?: boolean;
    outline?: boolean;
}

export const mutateFontSizeToExcelJsFormat = (fontSize: IExportExcelStylesFont): IFontExcelJs | undefined => {
    if (!fontSize) {
        return
    }

    return {
        ...fontSize,
        color: mutateColorToExcelJsFormat(fontSize.color),
        size: fontSize?.sz ? Number(fontSize?.sz) : undefined
    }
}